export function parseContentDispositionFilename(
    contentDisposition: string | undefined | null,
    fallback: string
): string {
    if (!contentDisposition) {
        return fallback
    }

    const rfc5987Match = /filename\*=([^']*)'([^']*)'([^;\n]*)/i.exec(contentDisposition)
    if (rfc5987Match?.[3]) {
        const charset = (rfc5987Match[1] || "").trim().toUpperCase().replace(/-/g, "")
        if (!charset || charset === "UTF8") {
            try {
                return decodeURIComponent(rfc5987Match[3].trim())
            } catch {
                // invalid percent-encoding — fall through to plain filename
            }
        }
    }

    const plainQuotedMatch = /(?:^|;)\s*filename=(?!\*)\s*"((?:\\.|[^"\\])*)"/i.exec(contentDisposition)
    if (plainQuotedMatch?.[1]) {
        const value = plainQuotedMatch[1].replace(/\\(.)/g, "$1").trim()
        if (value) {
            return value
        }
    }

    const plainUnquotedMatch = /(?:^|;)\s*filename=(?!\*)\s*([^;\n]+)/i.exec(contentDisposition)
    if (plainUnquotedMatch?.[1]) {
        const value = plainUnquotedMatch[1].trim()
        if (value) {
            return value
        }
    }

    return fallback
}
